import React from "react";

const NotFound = () => {
  return (
    <div className="h-screen w-full text-center text-red-600 text-3xl "> 404 ...</div>
  );
};
export default NotFound;
